import axios from "axios";
import {
  AI_ENDPOINT,
  DELETE_DOCUMENTS_ENDPOINT,
  DOCUMENT_DETAILS,
  FAVORITE_COPIES,
  SEARCH_DOCUMENTS_ENDPOINT,
} from "./endpoints";
import { showToast } from "../_utils/showToast";
import {
  DELETE_DOCUMENT,
  RESET_DOCUMENT,
  UPDATE_DOCUMENT,
  GET_DOCUMENTS,
  EDIT_DOCUMENT,
  RESET_DOCUMENT_CHANGES,
  SET_SELECTED_TEXT,
  GET_AI_TEMPLATES,
  TOGGLE_INPUT_FORM,
  GENERATE_RESULTS,
  PREPEND_AI_RESULTS,
  UPDATE_PROMPT,
  TOGGLE_LOADING_STATE,
  GET_AI_TEMPLATES_LIST,
  RESET_AI_TEMPLATES_LIST,
  AI_TEMPLATE_GET_ADDED,
  NEW_AI_RESULTS,
} from "./types";
import { handleHTTPError } from "./errorHandlerActions";
import Format from "string-format";
import { t } from "i18next";

const format = require("string-format");

export const updateDocument = (payload) => {
  return {
    type: UPDATE_DOCUMENT,
    payload: payload,
  };
};

export const editDocument = (payload) => {
  return {
    type: EDIT_DOCUMENT,
    payload: payload,
  };
};

export const resetDocument = () => {
  return {
    type: RESET_DOCUMENT,
  };
};

export const resetDocumentChanges = () => {
  return {
    type: RESET_DOCUMENT_CHANGES,
  };
};

export const getDocuments = (props, search, signal) => (dispatch) => {
  const { creatorId, excludeCreatorId } = props;

  let endpoint = new URL(SEARCH_DOCUMENTS_ENDPOINT);

  if (search) {
    endpoint.searchParams.append("search", `title:${search}`);
  }
  if (creatorId) {
    endpoint.searchParams.append("creator_id", creatorId);
  }
  if (excludeCreatorId) {
    endpoint.searchParams.append("exclude_creator__id", excludeCreatorId);
  }

  return new Promise((resolve, reject) => {
    axios
      .get(endpoint.href, signal)
      .then((res) => {
        resolve(res.data);

        dispatch({
          type: GET_DOCUMENTS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(handleHTTPError(error, props));
      });
  });
};

export const getFavoriteCopies = (props, search, signal) => (dispatch) => {
  let endpoint = FAVORITE_COPIES;
  if (search) {
    endpoint = Format("{0}?search={1}", endpoint, search);
  }
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint, signal)
      .then((res) => {
        resolve(res.data);
        dispatch({
          type: GET_DOCUMENTS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(handleHTTPError(error, props));
      });
  });
};

export const deleteDocument = (documentId, signalToken) => (dispatch) => {
  showToast({
    description: t("delete_ai_doc_msg", { ns: "ai" }),
    title: t("delete_ai_doc_title", { ns: "ai" }),
    status: "info",
  });

  let data = { cancelToken: signalToken };
  return axios
    .delete(format(DELETE_DOCUMENTS_ENDPOINT, documentId), data)
    .then((res) => {
      dispatch({
        type: DELETE_DOCUMENT,
        payload: documentId,
      });
      showToast({
        description: t("delete_doc_success_msg", { ns: "ai" }),
        title: t("success", { ns: "common" }),
        status: "success",
      });
      return res;
    })
    .catch((error) => {
      showToast({
        description: t("delete_doc_error_msg", { ns: "ai" }),
        title: t("failed", { ns: "common" }),
        status: "error",
      });
      dispatch(handleHTTPError(error, documentId));
    });
};

export const setSelectedText = (payload) => {
  return {
    type: SET_SELECTED_TEXT,
    payload: payload,
  };
};

export const fetchAiTemplates =
  (props, key = "", signalToken, page = 1, searchTerm, isLoaded, isSelect) =>
  (dispatch) => {
    let params = {
      page: page,
      search: searchTerm,
    };
    if (key) params.categories = key;
    return new Promise((resolve, reject) => {
      axios
        .get(AI_ENDPOINT, {
          cancelToken: signalToken.token,
          params,
        })
        .then((res) => {
          resolve(res.data.results);
          if (isSelect) {
            dispatch({
              type: GET_AI_TEMPLATES_LIST,
              payload: res.data.results,
              loadMore: res.data.next !== null,
              previous: res.data.previous,
            });
          } else {
            dispatch({
              type: GET_AI_TEMPLATES,
              payload: res.data.results,
              loadMore: res.data.next !== null,
            });
          }
          if (isLoaded) isLoaded(false);
        })
        .catch((error) => {
          dispatch(handleHTTPError(error, props));
        });
    });
  };

export const resetAiTemplatesList = () => {
  return {
    type: RESET_AI_TEMPLATES_LIST,
  };
};

export const templateGetAdded = (templates) => {
  return {
    type: AI_TEMPLATE_GET_ADDED,
    payload: templates,
  };
};

export const changeTemplate =
  (props, selectedTemplate, signalToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
      const payload = {
        prompt: selectedTemplate?.value
          ? selectedTemplate.value.id
          : selectedTemplate.id,
      };
      // Don't send anything else beside templateid
      axios
        .patch(
          Format(
            DOCUMENT_DETAILS,
            props.document ? props.document.data.id : props
          ),
          payload,
          {
            cancelToken: signalToken.token,
          }
        )
        .then((res) => {
          dispatch(updateDocument(res.data));
          resolve(res.data);
        })
        .catch((error) => {
          dispatch(handleHTTPError(error, props));
        });
    });
  };

export const toggleInputForm = (state) => {
  return {
    type: TOGGLE_INPUT_FORM,
    payload: state,
  };
};

export const toggleResultGeneration = (state) => {
  return {
    type: GENERATE_RESULTS,
    payload: state,
  };
};

export const prependAiResults = (state) => {
  return {
    type: PREPEND_AI_RESULTS,
    newPayload: state,
  };
};

export const newAiresults = (state) =>{
  return{
    type: NEW_AI_RESULTS,
    newPayload:state
  }
}

export const updatePrompt = (state) => {
  return {
    type: UPDATE_PROMPT,
    payload: state,
  };
};

export const toggleLoadingState = (value) => {
  return {
    type: TOGGLE_LOADING_STATE,
    payload: value,
  };
};

// @NOTE Disabled, require changes for AI
// https://www.notion.so/sosimplified/Python-API-for-post-editor-for-AI-2cb806f6a7094e82b93dadb9506e459e
// export const openNewAiDocumentInPanel =
//   (cancelToken) => (dispatch) => {
//     return new Promise((resolve, reject) => {
//       axios
//         .post(NEW_DOCUMENTS_ENDPOINT, {}, { cancelToken })
//         .then((res) => {
//           batch(() => {
//             dispatch(resetDocument());

//             dispatch(updateDocument(res.data));

//             dispatch(openAdvancedSettings(
//               ADVANCED_AI_EDITOR_PANEL,
//               ADVANCED_AI_RESULTS,
//               res.data.id
//             ));
//           });

//           resolve(res.data);
//         })
//         .catch((error) => {
//           dispatch(handleHTTPError(error));
//           reject(error);
//         });
//     });
//   };

// @NOTE Disabled, require changes for AI
// https://www.notion.so/sosimplified/Python-API-for-post-editor-for-AI-2cb806f6a7094e82b93dadb9506e459e
// export const updateDocumentData =
//   (id, data, cancelToken) => (dispatch) => {
//     return new Promise((resolve, reject) => {
//       axios
//         .patch(Format(DOCUMENT_DETAILS, id), data, {
//           cancelToken,
//         })
//         .finally(() => {
//           axios
//             .get(Format(DOCUMENT_DETAILS, id), {
//               cancelToken
//             })
//             .then((res) => {
//               dispatch(updateDocument(res.data));
//               resolve(res.data);
//             })
//             .catch((error) => {
//               dispatch(handleHTTPError(error));
//               reject(error);
//             });
//         });
//     });
//   };
